module.exports = __webpack_public_path__ + "img/img-aa59a4ac.630c0631.png";